import React from 'react';
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import LoanRequestSuccess from 'assets/loan/loan-request-success.png';

import { RecoverySuccessModalProps } from './types';
import { ACTION_MODAL_Z_INDEX } from 'components/SalaryStructures/creation/components/styles';

export const RecoverySuccessModal = ({
  isOpen,
  onDismiss,
  loanId,
  title,
  description,
}: RecoverySuccessModalProps) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size="small" zIndex={ACTION_MODAL_Z_INDEX}>
      <ModalHeader />
      <ModalBody>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="spacing.3"
          paddingY="spacing.4"
          textAlign="center">
          <Box display="flex" flexDirection="column" gap="spacing.6">
            <img src={LoanRequestSuccess} alt="Success" width={80} height={80} />
            {loanId && (
              <Text size="small" variant="body" weight="regular" color="surface.text.gray.muted">
                ID #{loanId}
              </Text>
            )}
          </Box>
          <Box display="flex" flexDirection="column" gap="spacing.3">
            <Heading size="small" weight="semibold" color="surface.text.gray.normal">
              {title}
            </Heading>
            <Text size="small" color="surface.text.gray.muted">
              {description}
            </Text>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button isFullWidth variant="secondary" onClick={onDismiss}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
